import { Component, Input, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { HubspotFormService } from '../../../Misc/services/hubspot-form.service';
import { HubspotFormTypeEnum } from '../../../Misc/enums/hubspot-form-type.enum';
import { ConfirmDialogComponent } from '../../../Dialogs/components/ConfirmDialog/confirm-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';

@Component({
    selector: 'agpr-mention-insight-upsell-card',
    templateUrl: './mention-insight-upsell-card.component.html',
    styleUrls: ['./mention-insight-upsell-card.component.scss'],
    standalone: false
})

export class MentionInsightUpsellCardComponent implements OnInit {
    readonly buttonTypes = ButtonTypesEnum;

    @Input() id = 'mentionInsightUpsellCard';

    isCollapsed: boolean = true;
    isWhiteLabeledBrand: boolean = false;

    constructor(
        protected configService: ConfigService,
        protected hubspotFormService: HubspotFormService,
        protected coreDialogService: CoreDialogService
    ) {}

    ngOnInit() {
        this.isWhiteLabeledBrand = this.configService.isWhiteLabelBrand();
    }

    unlock(): void {
        if (this.configService.brandGUIDIsBurrelles()) {
            window.location.href = 'mailto:inquiry@burrelles.com?subject=Sales%20Inquiry%20-%20Burrelles%20Contact%20Database';
        } else if (this.configService.brandGUIDIsPaMedia()) {
            window.location.href = 'mailto:salesadminteam@pamediagroup.com?'+
            'subject=Urgent%3A%20Agility%20Feature%20Upgrade%20Request&'+
            'body=Hello%2C%0A%0AI%27m%20interested%20in%20upgrading%20to%20include%20the%20%22Intelligent%20Insights%22%20feature%20in%20my%20plan.';
        } else {
            this.hubspotFormService.submitForm(HubspotFormTypeEnum.INTELLIGENT_INSIGHTS).then(() => {
                this.coreDialogService.open(
                    ConfirmDialogComponent,
                    {
                        inputs: {
                            heading: 'Mention.insights.upsell.unlock.confirmation.header',
                            messageHtml: 'Mention.insights.upsell.unlock.confirmation.message',
                            cancelLabel: 'cancel',
                            width: 600
                        }
                    }
                );
            }).catch(err => {
                window.open('https://www.agilitypr.com/contact/');
            });
        }
    }
}
